module.exports = __webpack_public_path__ + "static/media/service3.0217b280.svg";